import { translate } from 'react-switch-lang';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { FormGroup, Input } from 'reactstrap';
import { useHttpClient } from '../../../../../security/hooks/axiosProvider';
import { natureProduct as typeNatureProduct } from '../../../model/types';

const DetailNatureProduct = (props) => {
  const [natureProduct, setNatureProduct] = useState(typeNatureProduct);
  const httpClient = useHttpClient(true);

  const getNatureProduct = useCallback(async () => {
    if (props.natureProduct.id !== undefined) {
      httpClient.current?.get(`/api/nature_product/${props.natureProduct.id}`).then((response) => {
        setNatureProduct(response.data);
      });
    }
  }, [httpClient, props.natureProduct.id]);

  useEffect(() => {
    getNatureProduct();
  }, [getNatureProduct]);

  return (
    <Fragment>
      <form className="needs-validation">
        <FormGroup className="form-row">
          <label htmlFor="natureProduct_name">{props.t('np')}</label>
          <input
            type="text"
            className="form-control"
            name="natureProduct_name"
            id="natureProduct_name"
            value={natureProduct.name}
            disabled
          />
        </FormGroup>
        <FormGroup className="form-row">
          <label htmlFor="natureProduct_description">{props.t('Description')}</label>
          <textarea
            value={natureProduct.description}
            className="form-control"
            id="natureProduct_description"
            rows={3}
            disabled
          ></textarea>
        </FormGroup>
        <FormGroup className="form-row">
          <label htmlFor="idActivity">{props.t('activity')}</label>
          <Input type={'select'} id="idActivity" name="idActivity" disabled>
            <option>{natureProduct.activity.name} </option>
          </Input>
        </FormGroup>
      </form>
    </Fragment>
  );
};
export default translate(DetailNatureProduct);
